// extracted by mini-css-extract-plugin
export default {"SocialButton":"SocialButtonLBhye","socialButton":"SocialButtonLBhye","linkedin":"linkedinlPDw7","google":"googlepN3uC","icon":"iconkl79i"};